import React from "react";
import PropTypes from "prop-types";
import styles from "./LosPluginItem.module.css";
import Link from "shared/Link";
import Button from "shared/Button";

/**
 *
 * Displays information about a LOS plugin in the LOS plugin list.
 */

export function LosPluginItem({
  onClick,
  pluginInfo,
  onTargetClick,
  onPlugeeClick,
}) {
  //To capitalized the first letter only
  function titleCase(text) {
    const titleCase = text
      .toLowerCase()
      .split(" ")
      .map((info) => {
        return info.charAt(0).toUpperCase() + info.slice(1);
      })
      .join(" ");

    return titleCase;
  }

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <Link to={`/membership/lookup/ibo/${pluginInfo.plugeeIBONumber}`}>
          {pluginInfo.plugeeIBONumber}
        </Link>
      </div>
      <div className={styles.item}>
        {titleCase(pluginInfo.plugeeOrganizationName)}{" "}
        {pluginInfo.plugeeBusinessType}
      </div>
      <div className={styles.item}>
        <Link to={`/membership/lookup/ibo/${pluginInfo.targetIBONumber}`}>
          {pluginInfo.targetIBONumber}
        </Link>
      </div>
      <div className={styles.item}>
        {titleCase(pluginInfo.targetOrganizationName)}{" "}
        {titleCase(pluginInfo.targetGroupName)}
      </div>
      {/* <div className={styles.item}>{pluginInfo.asPin}</div> */}
      {/* <div className={styles.item}>
        {pluginInfo.replaceOriginal ? "YES" : "NO"}
      </div> */}
      <div>
        <Button className={styles.detailsBtn} size="small" onClick={onClick}>
          Details
        </Button>
      </div>
    </div>
  );
}

LosPluginItem.propTypes = {
  /**
   * Function called when details is clicked
   */
  onClick: PropTypes.func,
  /**
   * Function called when the target is clicked
   */
  onTargetClick: PropTypes.func,
  /**
   * 	Function called when the plugee is clicked
   */
  onPlugeeClick: PropTypes.func,
  /**
   * Object with the plugin info
   */
  // pluginInfo: PropTypes.objectOf(
  //   PropTypes.shape({
  //     id: PropTypes.string,
  //     plugee: PropTypes.string,
  //     target: PropTypes.string,
  //     asPin: PropTypes.string,
  //     date: PropTypes.string,
  //     time: PropTypes.string,
  //   })
  // ),

  pluginInfo: PropTypes.shape({
    id: PropTypes.string,
    plugeeIBONumber: PropTypes.string,
    plugeeOrganizationName: PropTypes.string,
    plugeeBusinessType: PropTypes.string,
    targetIBONumber: PropTypes.string,
    targetOrganizationName: PropTypes.string,
    targetGroupName: PropTypes.string,
    // ... other properties you might be using ...
  }),
};

LosPluginItem.defaultProps = {
  onClick: () => alert("Details btn clicked"),
};
